﻿import React, { Fragment, Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate} from 'react-router-dom';
import {AuthProvider, useAuth } from '../context/AuthContext';
import SessionTimeout from './session_timeout'; // Importa o componente de expiração de sesséo
import 'bootstrap-icons/font/bootstrap-icons.css';

// ⚡ Importações NORMAIS - Componentes pequenos/créticos que devem carregar rápido
import Login from '../pages/login/login';
import Unauthorized from '../pages/permissoes/unauthorized';

// 🚀 LAZY LOADING - Componentes pesados que seréo carregados sob demanda
// Isso melhora significativamente o tempo de carregamento inicial

// páginas principais
const Home = React.lazy(() => import('../pages/home/home'));
const Ativacao = React.lazy(() => import('../pages/login/ativacao'));
const RedefinirSenha = React.lazy(() => import('../pages/login/redefinir_senha'));

// páginas de Cadastro
const CadEntidade = React.lazy(() => import('../pages/cadastro/cad_entidade'));
const CadMotorTemp = React.lazy(() => import('../pages/cadastro/cad_motorista_temp'));
const EntConsulta = React.lazy(() => import('../pages/cadastro/cad_entidade_consulta'));
const CadAgendamento = React.lazy(() => import('../pages/cadastro/cad_agendamento'));
const CadDevolucao = React.lazy(() => import('../pages/cadastro/cad_devolucao'));
const ConsultaAgend = React.lazy(() => import('../pages/cadastro/consul_agendamento'));
const ConsultaDevol = React.lazy(() => import('../pages/cadastro/consul_devolucao'));
const UsuariosAntomar = React.lazy(() => import('../pages/cadastro/usuarios_Antom'));
const Usuarios = React.lazy(() => import('../pages/cadastro/usuarios'));
const Contatos = React.lazy(() => import('../pages/cadastro/contatos'));

// páginas de Consulta
const AgendamentoViewModal = React.lazy(() => import('../pages/consulta/agendamento_view_modal'));
const DevolucaoViewModal = React.lazy(() => import('../pages/consulta/devolucao_view_modal'));
const QRConsulta = React.lazy(() => import('../pages/consulta/qr_consulta'));
const PreEntrada = React.lazy(() => import('../pages/consulta/pre_entrada'));

// Página de Manutenção
const Manutencao = React.lazy(() => import('../pages/manutencao/manutencao'));
const FAQ = React.lazy(() => import('../pages/manutencao/faq'));
const Calendario = React.lazy(() => import('../pages/manutencao/calendario'));

const Private = ({ Item, requiredPermissions, isLazy = false }) => {
  const { permissions, loaded } = useAuth();
  const token = localStorage.getItem('token');

  if (!loaded) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Carregando...</span>
          </div>
          <div className="mt-3">
            <p className="text-muted">Carregando autenticação...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  const hasPermission = requiredPermissions.some(permission => permissions[permission]);

  if (!hasPermission) {
    return <Navigate to="/unauthorized" />;
  }

  if (isLazy) {
    return (
      <Suspense fallback={
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Carregando...</span>
            </div>
            <div className="mt-3">
              <p className="text-muted">Carregando página...</p>
            </div>
          </div>
        </div>
      }>
        <Item />
      </Suspense>
    );
  }

  return <Item />;
};
  
  const RouteApp = () => {
    return (
      <AuthProvider>
      <BrowserRouter>
        <SessionTimeout>
        <Fragment>
          <Routes>
            {/* Rota pública - QR Consulta sem necessidade de login */}
            <Route path="/qr_consulta" element={
              <Suspense fallback={
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                    <div className="mt-3">
                      <p className="text-muted">Carregando página...</p>
                    </div>
                  </div>
                </div>
              }>
                <QRConsulta />
              </Suspense>
            }/>
            {/* Rota pública - Cadastro de Motorista Temporário sem necessidade de login */}
            <Route path="/motorista-temp" element={
              <Suspense fallback={
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                    <div className="mt-3">
                      <p className="text-muted">Carregando página...</p>
                    </div>
                  </div>
                </div>
              }>
                <CadMotorTemp />
              </Suspense>
            }/>
            {/* Rota pública - Redefinição de Senha sem necessidade de login */}
            <Route path="/redefinir-senha" element={
              <Suspense fallback={
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                    <div className="mt-3">
                      <p className="text-muted">Carregando página...</p>
                    </div>
                  </div>
                </div>
              }>
                <RedefinirSenha />
              </Suspense>
            }/>
            {/* Rota pública - Ativação sem necessidade de login */}
            <Route path="/ativacao" element={
              <Suspense fallback={
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                    <div className="mt-3">
                      <p className="text-muted">Carregando página...</p>
                    </div>
                  </div>
                </div>
              }>
                <Ativacao />
              </Suspense>
            }/>
            
            {/* GERAL */}
            <Route path="*" element={<Private Item={Home} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />} />
            <Route path="/login" element={<Login/>} />
            <Route path="/home" element={<Private Item={Home} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />} />
            <Route path="/unauthorized" element={<Unauthorized/>}/>
            {/* CADASTROS */}
            <Route path="/cadastro_retirada" element={<Private Item={CadAgendamento} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />}/>
            <Route path="/cadastro_entidade" element={<Private Item={CadEntidade} requiredPermissions={['admin','gGeral','dev','cliente','clienteSup']} isLazy={true} />} />
            <Route path="/cadastro_devolucao" element={<Private Item={CadDevolucao} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />}/>
            <Route path="/permissoes_cadastro" element={<Private Item={useAuth} requiredPermissions={['admin','gGeral','dev']} isLazy={true} />} />
            <Route path="/contatos" element={<Private Item={Contatos} requiredPermissions={['admin','gGeral','dev','clienteSup']} isLazy={true} />} />
            {/* CONSULTAS */}
            <Route path="/consulta_entidade"element={<Private Item={EntConsulta} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />} />
            <Route path="/consulta_retirada" element={<Private Item={ConsultaAgend} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />}/>
            <Route path="/consulta_devolucao" element={<Private Item={ConsultaDevol} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />}/>
            <Route path="/detalhes_retirada" element={<Private Item={AgendamentoViewModal} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />}/>
            <Route path="/detalhes_devolucao" element={<Private Item={DevolucaoViewModal} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />}/>
            <Route path="/pre_entrada" element={<Private Item={PreEntrada} requiredPermissions={['admin','gGeral','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />}/>

            {/* USUARIOS SISTEMA ANTOMAR */}
            <Route path="/usuarios_ant" element={<Private Item={UsuariosAntomar} requiredPermissions={['admin','gGeral','dev']} isLazy={true} />} />
            {/* USUARIOS*/}
            <Route path="/usuarios" element={<Private Item={Usuarios} requiredPermissions={['admin','gGeral','dev','clienteSup']} isLazy={true} />}/>

            {/* MANUTENÇAO */}
            <Route path="/manutencao" element={<Private Item={Manutencao} requiredPermissions={['admin','gGeral','dev','supDoc']} isLazy={true} />} />
            <Route path="/calendario" element={<Private Item={Calendario} requiredPermissions={['admin','gGeral','dev','supDoc']} isLazy={true} />} />
            <Route path="/faq" element={<Private Item={FAQ} requiredPermissions={['admin','gGeral','cliente','clienteSup','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev']} isLazy={true} />} />
          </Routes>
        </Fragment>
        </SessionTimeout>
      </BrowserRouter>
      </AuthProvider>
    );
  };
  
  export default RouteApp;

 //'admin','gGeral','cliente','gate','documental','agendamento','supDoc','avaria','supAva','vistoria','conferente','oficina','gerencPatio','dev'
 // admin,gGeral,cliente,gate,documental,agendamento,supDoc,avaria,supAva,vistoria,conferente,oficina,gerencPatio,dev
 // permissions.admin || permissions.gGeral || permissions.cliente || permissions.gate || permissions.documental || permissions.agendamento || permissions.supDoc || permissions.avaria || permissions.supAva || permissions.vistoria || permissions.conferente || permissions.oficina || permissions.gerencPatio || permissions.dev